import React, { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import axios from '../../axiosConfig';
//特别注意
// import axios from "axios";
import { useAuth } from "../../context/AuthContext";
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import '../../styles/BookingPage.css';

const BookingPage = () => {
  const { technicianId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth(); // 获取当前登录用户
  const { t } = useTranslation();

  console.log("location",location);

  // 发送预约确认邮件
  const sendBookingConfirmationEmail = async (appointmentData, paymentMethodText) => {
    try {
      // 检查用户是否有邮箱
      let userEmail = user.youxiang || user.zhanghao;
      if (!userEmail || !userEmail.includes('@')) {
        console.log("用户没有邮箱，跳过邮件发送");
        return;
      }

      const emailData = {
        toEmail: userEmail,
        customerName: user.xingming || user.zhanghao,
        coachName: appointmentData.jiaolianxingming,
        serviceName: appointmentData.projectName,
        bookingTime: appointmentData.startTime,
        paymentMethod: paymentMethodText,
        amount: appointmentData.price
      };

      const response = await axios.post('/booking-notification/send-confirmation', emailData);
      
      if (response.data.code === 0) {
        console.log("预约确认邮件发送成功");
      } else {
        console.warn("预约确认邮件发送失败：" + response.data.msg);
      }
    } catch (error) {
      console.error("发送预约确认邮件异常：", error);
    }
  };
  
const { service, technician, serviceDuration, calculatedPrice } = location.state || {};
  const [availableTimes, setAvailableTimes] = useState([]);
  const [selectedTime, setSelectedTime] = useState('');
  const [paymentMethod, setPaymentMethod] = useState(1); // 1: 在线支付, 2: 到店付款

  // Fetch available times for the selected technician
  // useEffect(() => {
  //   if (technician.jiaolianbianhao) {
  //     axios.get(`/schedule/${technician.jiaolianbianhao}/availability`)
  //       .then((response) => {
	//   console.log("ava",response);

  //         if (response.data.code === 0) {
  //           setAvailableTimes(response.data.data);
  //           if (response.data.data.length > 0) {
  //             console.log("response.data.data[0]",response.data.data[0]);

  //             setSelectedTime(response.data.data[0]); // Default to the earliest time
  //           }
  //         }
  //       })
  //       .catch((error) => console.error('Error fetching available times:', error));
  //   }
  // }, [technicianId]);
  useEffect(() => {
    if (technician?.jiaolianbianhao && serviceDuration) {
      const formData = new URLSearchParams();
      formData.append("coachId", technician.jiaolianbianhao);
      formData.append("durationMinutes", serviceDuration);
  
      axios.post(
        `/schedule/getAvailableStartTimes`,
        formData,
        { headers: { "Content-Type": "application/x-www-form-urlencoded" } }  // ⬅ 关键
      )
      .then((response) => {
        console.log("ava", response);
        if (response.data.code === 0) {
          console.log("response.data.getAvailableStartTimes",response.data.getAvailableStartTimes);
          
          setAvailableTimes(response.data.getAvailableStartTimes);
          if (response.data.getAvailableStartTimes.length > 0) {
            setSelectedTime(response.data.getAvailableStartTimes[0]);
          }
        }
      })
      .catch((error) => console.error('Error fetching available times:', error));
    }
  }, [technician, serviceDuration]);
  
  

  // Handle booking submission
  // const handleBooking = () => {
  //   const bookingData = {
  //     serviceId: service?.id,
  //     technicianId: technician?.id,
  //     time: selectedTime,
  //     userId: 1, // Replace with the logged-in user's ID
  //   };

  //   axios.post('/booking/create', bookingData)
  //     .then((response) => {
  //       if (response.data.code === 0) {
  //         alert('Booking successful!');
  //         navigate('/user/bookings'); // Redirect to user's bookings page
  //       } else {
  //         alert('Booking failed: ' + response.data.msg);
  //       }
  //     })
  //     .catch((error) => console.error('Error creating booking:', error));
  // };
  // 处理确认预约
  const handleConfirmBooking = () => {
    if (!user) {
      alert("请先登录");
      navigate("/login");
      return;
    }

    if (!selectedTime) {
      alert("请选择预约时间");
      return;
    }

    // 组织预约数据并跳转到支付页面
    const bookingData = {
      userId: user.id,
      service,
      technician,
      selectedTime,
      calculatedPrice,
      serviceDuration,
      paymentMethod
    };

    if (paymentMethod === 1) {
      // 在线支付，跳转到支付页面
      navigate("/payment", { state: bookingData });
    } else {
      // 到店付款，直接提交预约
      // 创建预约对象
      const appointmentData = {
        coachId: technician.jiaolianbianhao,
        jiaolianbianhao: technician.jiaolianbianhao,
        jiaolianxingming: technician.jiaolianxingming,
        startTime: selectedTime, // 这里保持字符串格式，传给后端时区会自动处理
        duration: serviceDuration,
        userId: user.id,
        zhanghao: user.zhanghao, // 确保添加用户账号
        xingming: user.xingming, // 确保添加用户姓名
        shouji: user.shouji, // 确保添加用户手机
        projectName: service.xiangmumingcheng,
        projectId: service.id,
        xiangmufenlei: service.xiangmuleixing, // 项目类型
        xiangmumingcheng: service.xiangmumingcheng, // 项目名称
        price: calculatedPrice,
        paymentMethod: 2, // 到店付款
        paymentStatus: 0, // 待支付
        status: "pending", // 完成状态
        sfsh: "否", // 未审核
        yuyueshuoming: `${service.xiangmumingcheng} 预约` // 预约说明
      };
      
      console.log("预约时间:", selectedTime);

      axios.post('/jiaolianyuyue/addWithoutApprove', appointmentData, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(response => {
        if (response.data.code === 0) {
          // 预约成功后发送邮件通知
          sendBookingConfirmationEmail(appointmentData, "到店付款");
          alert("预约成功，请到店付款");
          navigate("/user/bookings");
        } else {
          alert("预约失败：" + response.data.msg);
        }
      })
      .catch(error => {
        console.error('Error:', error);
        alert(t('booking.bookingFailed'));
      });
    }
  };

  return (
    <div className="booking-page">
      {/* 后退按钮 */}
      <div className="page-header">
        <button className="back-button" onClick={() => navigate(-1)}>
          <FontAwesomeIcon icon={faArrowLeft} />
          {/* <span>返回</span> */}
        </button>
      </div>
      
      <h1>{t('booking.appointmentDetail')}</h1>

      {/* Service Information */}
      <div className="">
        <h3>{t('booking.serviceInfo')}</h3>
        <p>{t('booking.name')}: {service?.xiangmumingcheng}</p>
        {/* <p>价格: {service?.jiage} 元</p> */}
        <p>{t('booking.price')}: {calculatedPrice} 元</p>
        <p>{t('booking.features')}: {service?.tedian}</p>
      </div>

      {/* Technician Information */}
      <div className="">
        <h3>{t('booking.technicianInfo')}</h3>
        <p>{t('booking.name')}: {technician?.jiaolianxingming}</p>
        <p>{t('booking.level')}: {technician?.jiaoliandengji}</p>
        <p>{t('booking.contact')}: {technician?.lianxidianhua}</p>
      </div>

      {/* Time Selection */}
      <div className="time-selection">
        <h3>{t('booking.selectAppointmentTime')}</h3>
        <select
          value={selectedTime}
          onChange={(e) => setSelectedTime(e.target.value)}
        >
          {availableTimes.length&&availableTimes.map((time, index) => (
            <option key={index} value={time}>
              {time}
            </option>
          ))}
        </select>
      </div>

      {/* Payment Method Selection */}
      <div className="payment-method">
        <h3>{t('booking.selectPaymentMethod')}</h3>
        <div className="payment-options">
          <label>
                          <input
                type="radio"
                value="1"
                checked={paymentMethod === 1}
                onChange={(e) => setPaymentMethod(Number(e.target.value))}
              />
              {t('booking.onlinePayment')}
            </label>
            <label>
              <input
                type="radio"
                value="2"
                checked={paymentMethod === 2}
                onChange={(e) => setPaymentMethod(Number(e.target.value))}
              />
              {t('booking.offlinePayment')}
            </label>
        </div>
      </div>

      {/* Submit Booking */}
      <button className="book-button" onClick={handleConfirmBooking}>
        {t('booking.confirmBooking')}
      </button>
    </div>
  );
};

export default BookingPage;
